import { Box, Typography, CircularProgress } from '@mui/material';
import Button from './Button';
import LogoMark from './LogoMark';

function AppStatus({ title, message, retry }) {
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 2, p: 5 }}>
      <LogoMark />
      <Typography variant="h4">{title}</Typography>
      <Typography color="text.secondary" sx={{ maxWidth: 560 }}>
        {message}
      </Typography>
      {retry ? (
        <Button onClick={retry} sx={{ width: 'fit-content' }}>
          Retry
        </Button>
      ) : (
        <CircularProgress sx={{ mt: 1 }} />
      )}
    </Box>
  );
}

export default AppStatus;
